import { OrderStatus, ErrorCode } from '@triplabo/web/services/types';

export default {
  views: {
    dashboard: {
      title: '대시보드'
    },
    home: {
      title: 'GO×Triplabo 택시',
      greeting: '지금 출발!',
      go: 'GO가 서비스 제공',
      loginButton: '로그인',
      destinationPlaceholder: '도착 위치',
      pickUp: '승차',
      recommendPickup: '추천 승차 지점',
      recommendDropOff: '추천 하차 지점',
      cannotUsePoint: '승차 불가 지역',
      nowPlace: '현재 위치',
      nowPlaceJa: '현재 위치',
      categories: {
        recommend: '추천',
        transportation: '교통편',
        attraction: '관광 명소',
        experience: '체험/액티비티'
      },
      viewDetail: '보기',
      status: {
        finding: {
          title: '차량을 찾고 있습니다',
          subtitle: '잠시만 기다려 주세요'
        },
        dispatching: {
          subtitle: '곧 차량이 도착합니다'
        },
        pickUpArrived: {
          subtitle: '차량이 도착했습니다. 기사에게 연락해 주세요'
        },
        onDeliver: {
          subtitle: '차량 운행 중입니다'
        }
      }
    },
    pickup: {
      title: '승차 지점 선택',
      searchPlaceholder: '승차 지점을 입력해 주세요',
      recommendTitle: '주변 추천 승차 지점',
      historyTitle: '이력',
      empty: '데이터가 없습니다',
      emptyTip: '다른 검색어나 지도에서 위치를 선택해 주세요',
      emptyButton: '지도에서 선택',
      deleteConfirm: '삭제하시겠습니까?',
      deleteConfirmRecall: '확인',
      deleteConfirmCancel: '취소',
      facilityTag: '추천'
    },
    pointChange: {
      searchUpPlaceholder: '승차 지점을 입력해 주세요',
      searchDownPlaceholder: '하차 지점을 입력해 주세요',
      title: '승차 위치 변경',
      titleDropOff: '하차 위치 변경',
      description: '지도 핀을 드래그하여 승차 위치 변경',
      descriptionDropOff: '지도 핀을 드래그하여 하차 위치 변경',
      confirm: '승차 위치 확인',
      confirmDropOff: '하차 위치 확인'
    },
    dropOff: {
      title: '하차 지점 선택',
      searchPlaceholder: '하차 지점을 입력해 주세요',
      recommendTitle: '근처 하차 지점을 추천해 드립니다'
    },
    orderConfirm: {
      discountApplied: '할인됨',
      paymentTimeoutDialog: {
        description:
          '현재 시스템이 원활하지 않습니다. 환불이 필요하신 경우, 고객센터로 문의해 주세요.',
        subtitle:
          '먼저 화면을 캡처한 후, 고객센터로 연락해 환불 절차를 진행해 주세요.',
        goToService: '스크린샷을 저장했습니다. 고객센터로 이동합니다.',
        orderIdLabel: '예약 번호'
      },
      paymentProcessing: '주문 확인 중입니다.프로그램을 닫지 말아 주세요',
      ascfPayConfirm: {
        content: '결제가 완료되었습니까?',
        confirm: '확인',
        notPaid:
          '결제가 확인되지 않았습니다. "내 여행"에서 주문 상태를 확인해 주세요'
      },
      title: '지금 택시를 호출하세요!',
      selectType: '차량 종류를 선택해 주세요',
      normal: '이코노미 택시',
      premium: '벤티 택시',
      wagon: '컴포트 택시',
      airport: '공항 할인 정액',
      airportTag: '고정 요금',
      airportTip:
        '엔화 고정 금액이며, 실제 금액은 당일 결제 평균 환율로 정산됩니다',
      confirm: '지금 전화',
      time: '약 {{min}}~{{max}}분 후 탑승 가능',
      estimate: '요금 예상',
      estimateTag: '예상 요금',
      discount: '할인됨',
      unit: '엔',
      coupon: '쿠폰',
      couponAvailable: '{{count}} 개 사용 가능',
      checkOrderFailed: '주문 상태 확인에 실패했습니다. 다시 시도해 주세요',
      callWaiting: {
        title: '현재 주변에 차량이 없습니다. 계속 호출하시겠습니까?',
        subtitle:
          '주변 차량을 계속 확인 중이며, 배차 가능한 차량이 확인되는 즉시 알려드리겠습니다.',
        confirm: '계속 호출',
        cancel: '호출 취소',
        finding: '주변 차량을 검색 중입니다…',
        dispatching: '차량을 배차 중입니다. 잠시만 기다려 주세요.',
        continueWaiting: '주변에 차량이 없습니다. 계속 기다리시겠습니까?',
        continue: '계속 기다리기',
        unwait: '기다리지 않기'
      }
    },
    profile: {
      title: '내 계정',
      order: '내 여행',
      coupon: '쿠폰',
      service: '고객 지원',
      userName: '사용자 이름',
      editProfile: '정보 편집',
      notLogin: '로그인이 필요합니다',
      goToLogin: '계정으로 로그인',
      logout: '로그아웃',
      creditCard: '신용카드 관리'
    },
    editUserInfo: {
      title: '개인 정보 수정',
      name: '이름 (로마자 표기)',
      email: '연락용 이메일 주소 (전자 영수증 수신용)',
      phone: '연락처 전화번호',
      confirm: '수정 내용 확인',
      emailError: '올바른 이메일 주소를 입력해 주세요',
      phoneError: '올바른 휴대폰 번호를 입력해 주세요',
      nameError: '올바른 이름을 입력해 주세요',
      success: '수정이 완료되었습니다',
      error: '수정에 실패했습니다. 잠시 후 다시 시도해 주세요'
    },
    order: {
      all: '전체',
      succeed: '완료',
      pending: '결제 대기 중',
      canceled: '취소됨',
      empty: '예약이 없습니다',
      emptyTip: '지금 택시를 호출',
      noMore: '더 이상 결과가 없습니다',
      orderId: '예약 번호',
      carType: {
        normal: '이코노미',
        premium: '프리미엄',
        wagon: '벤티 택시',
        airport: '공항 할인 정액',
        any: '이코노미'
      },
      status: {
        [OrderStatus.Succeed]: '완료',
        [OrderStatus.Canceled]: '취소됨',
        [OrderStatus.Finding]: '차량 호출 중',
        [OrderStatus.DispatchFailed]: '차량 호출 중',
        [OrderStatus.Dispatching]: '탑승 중',
        [OrderStatus.PickUpArrived]: '운행 중',
        [OrderStatus.OnDeliver]: '운행 중',
        [OrderStatus.DropOff]: '완료됨',
        pending: '결제를 진행해 주세요'
      },
      money: '{{amount}}'
    },
    payment: {
      title: '사전 결제 요금',
      description:
        '원활한 예약을 위해 예상 요금 기준으로 사전 결제를 진행해 주세요. 실제 요금은 탑승 후 정산되며, 차액은 환불 또는 추가 청구됩니다.',
      wechat: 'WeChat 결제',
      wechatDesc: '(중국 WeChat 사용자 전용) 위안화로 결제해 주세요',
      agreement: "사전 결제 약관'에 동의합니다",
      agreementLink: '사전 결제 약관',
      confirm: '{{amount}} 엔을 사전 결제하고 지금 택시를 호출',
      money: '{{amount}} 위안',
      support: '지원'
    },
    cancelOrder: {
      success: '배차 예약이 취소되었습니다',
      confirmCancel: {
        title: '배차 예약 취소를 확인',
        warning:
          '배차 예약을 취소하면 취소 수수료가 발생할 수 있습니다. 정말로 취소하시겠습니까?',
        note: '잦은 취소는 향후 배차 제한으로 이어질 수 있습니다. 양해 부탁드립니다',
        viewRules: '취소 정책 보기',
        waitMore: '조금 더 기다릴게요',
        confirm: '배차 예약을 취소',
        cancelFee: '취소 수수료',
        cancelFeeDescription: '{{amount}}위안'
      },
      selectReason: {
        title: '취소 사유 선택',
        submit: '제출',
        otherReason: '기타',
        customReasonPlaceholder:
          '기타를 선택한 경우, 여기에 내용을 입력해 주세요',
        reasons: {
          platform: {
            title: '플랫폼 관련',
            content: {
              tooFar: '배차된 차량이 너무 멀리 있음',
              inaccurateLocation:
                '위치 정보가 정확하지 않음 / 승차 장소를 찾을 수 없음',
              notExpectedCar: '예상과 다른 차량'
            }
          },
          driver: {
            title: '기사 관련',
            content: {
              driverNotComing:
                '기사가 오지 않음 (차량 위치가 멀어지거나 정지 상태)',
              driverNotContactable: '기사와 연락이 되지 않음 / 찾을 수 없음',
              driverCancel: '기사 측에서 예약을 취소함',
              driverLate: '차량 도착이 늦음',
              driverNotMatch: '배정된 차량과 기사 정보가 일치하지 않음'
            }
          },
          self: {
            title: '승객 사유',
            content: {
              selfChange: '일정 변경으로 택시가 필요 없어짐',
              otherPlatform: '다른 앱을 통해 호출함',
              cannotArrive: '승차 위치에 도달할 수 없음'
            }
          }
        }
      }
    },
    fareEstimate: {
      title: '예상 요금',
      unit: 'JPY',
      hero: {
        title: '예상 요금 안내',
        subtitle: '빠른 응답, 신속한 픽업, 합리적인 가격'
      },
      fee: {
        title: '요금 구성 예상',
        totalLabel: '예상 금액',
        approx: '약',
        range: '{{min}}~{{max}}',
        items: {
          transport: '운송 요금（수수료 포함）',
          carTypeFee: '차종 요금',
          pickup: '픽업 요금',
          dispatch: '배차 요금（원거리 배차 등 포함）',
          service: '플랫폼 수수료',
          regional: '지역 진흥 요금',
          peak: '피크 조정',
          etc: '통행료（ETC 등 포함）',
          coupon: '쿠폰 할인'
        },
        notes: {
          estimate:
            '예상 요금은 실제 교통 상황, 예상 주행 거리, 소요 시간, 환율 변동 등을 기준으로 산출되며 변동될 수 있어 참고용으로만 사용해 주세요.',
          service: '플랫폼 수수료는 실제 주행 거리에 따라 단계별로 계산됩니다.',
          extra:
            '고속도로 요금, 교량·도로 요금 등 운행 중 실제로 발생한 기타 추가 요금은 예상 요금에 포함되지 않으며, 최종 금액은 운행 종료 후 실제 결제 금액을 기준으로 합니다.'
        }
      },
      faq: {
        title: '자주 묻는 질문',
        q: '문',
        a: '답',
        items: {
          why: {
            question: '왜 실제 요금이 예상 요금보다 비쌀 수 있나요?',
            answer:
              '예약 전 표시되는 요금은 예상 금액일 뿐이며, 실제 요금이 더 높을 경우 교통 정체, 도중 정차, 통행료 등 추가 비용에 의해 변동될 수 있습니다.'
          },
          extraFee: {
            question: '추가 요금은 승객이 부담하나요?',
            answer:
              '운행 중 발생한 고속도로 요금, 통행료, 주차 요금 등 추가 비용은 실제 사용량에 따라 승객이 부담합니다.'
          },
          routeChange: {
            question: '경로 변경이 요금에 영향을 미치나요?',
            answer:
              '실제 교통 상황이나 승객의 요청으로 경로가 변경된 경우, 최종 결제 금액은 실제 주행 거리와 소요 시간에 따라 정산됩니다.'
          },
          cancelFee: {
            question: '주문을 취소하면 취소 수수료가 발생하나요?',
            answer:
              '기사 배차 후 무료 취소 시간이 지나거나 기사가 픽업 지점에 도착한 뒤 취소할 경우, 규정에 따라 취소 수수료가 부과됩니다.'
          }
        }
      }
    },
    orderDetail: {
      empty: '데이터가 없습니다',
      serviceProvider: 'Service provided by GO Inc.',
      more: {
        title: '더보기',
        orderId: '주문 번호: {{orderId}}'
      },
      finding: {
        title: '택시를 찾는 중입니다… ',
        estimatedTime:
          '{{time}}분 이내에 응답 예정입니다. 잠시만 기다려 주세요',
        cancelButton: '배차 예약을 취소함'
      },
      remaining: '남은',
      minutes: '분',
      meter: '미터',
      kilometers: '킬로미터',
      canceled: {
        title: '주문이 취소되었습니다',
        subtitle: '필요하다면 차량을 다시 호출해 주세요',
        provider: '이 서비스는 GO Inc.에서 제공합니다',
        customerService: '고객 서비스에 문의',
        paymentDetail: '선결제 내역',
        recallButton: '다시 차량을 호출해 주세요',
        backHome: '홈으로 돌아가기'
      },
      succeed: {
        title: '탑승 완료',
        provider: '이 서비스는 GO Inc.에서 제공합니다',
        actualPay: '결제 금액',
        unit: '위안',
        customerService: '고객센터 문의',
        getInvoice: '영수증 발급',
        drivingFee: '승차 요금',
        additionalPaymentAmount: '추가 결제 금액',
        prepaid: '요금 계산 중',
        discount: '할인 금액'
      },
      getInvoice: {
        title: '전자 영수증 발급',
        description: '전자 영수증은 이메일 첨부파일로 전송됩니다',
        invoiceTitle: '청구서 제목',
        invoiceTitlePlaceholder: '청구서 제목을 입력해 주세요',
        email: '이메일 주소',
        emailPlaceholder: '이메일 주소를 입력해 주세요',
        emailError: 'Please enter a valid email address',
        remark: '비고',
        remarkPlaceholder: '비고를 입력해 주세요',
        submit: '전송',
        success: '영수증이 이메일로 발송되었습니다',
        error: '영수증 발송에 실패했습니다. 다시 시도해 주세요'
      },
      confirmDialog: {
        noDriver: '주변에 차량이 없습니다. 다시 시도하시겠습니까?',
        recall: '다시 시도',
        cancel: '주문 취소',
        driverCancel:
          '기사가 예약을 취소했습니다. 환불은 곧 월렛으로 처리됩니다',
        driverCancelConfirm: '확인했습니다'
      },
      rideCode: {
        title: '탑승 코드',
        description: '탑승 후 아래의 코드를 기사에게 보여주세요',
        waitingNumber: '대기 번호',
        destination: '목적지'
      },
      receive: {
        cardTitle: '탑승 후, 탑승 코드를 기사에게 보여주세요',
        viewCode: '탑승 코드 확인',
        dispatchingText: '기사가 주문을 수락했습니다',
        dispatchingDescription: '기사가 오고 있습니다',
        pickUpArrivedText: '차량이 도착했습니다',
        pickUpArrivedDescription: '기사에게 연락 후 바로 탑승해 주세요',
        onDeliverText: '목적지로 이동 중',
        onDeliverDescription: '운행이 시작되었습니다. 안전벨트를 착용해 주세요',
        message: '메시지 보내기',
        cancelOrder: '배차 예약 취소',
        shareTrip: '탑승 공유'
      }
    },
    repay: {
      statusText: '결제 대기 중...',
      serviceProvider: '이 서비스는 GO Inc.에서 제공합니다.',
      service: '고객센터 문의',
      paidText: '추가 요금 결제',
      unit: '위안',
      feeUnit: '{{amount}}',
      repayment: '추가 요금',
      drivingFee: '탑승 요금',
      prepaidAmount: '사전 결제'
    },
    repayDetail: {
      title: '사전 결제 상세',
      prepaymentAmount: '사전 결제 금액',
      actualUsage: '운행이 완료되었습니다',
      unusedPrepayment: '사용되지 않은 사전 결제 금액',
      finishedRefund:
        '예약이 완료되었습니다. 미사용 사전 결제 금액은 원래 결제 수단으로 환불됩니다',
      unusedPrepaymentRefund:
        '예약이 취소되었습니다. 미사용 사전 결제 금액은 원래 결제 수단으로 환불됩니다',
      paymentReminder: '추가 요금 결제가 필요합니다. 결제를 진행해 주세요',
      additionalFarePaid: '예약 완료, 추가 요금 결제 완료',
      cancelFee: '취소 수수료',
      insufficientPrepaymentNotice:
        '사전 결제 금액이 예상 요금보다 부족할 경우, 부족분을 결제해야 서비스를 계속 이용할 수 있습니다',
      bankProcessingNote:
        '실제 환불 시점은 은행 처리 일정에 따라 다를 수 있습니다. 7영업일 이내 환불이 되지 않으면 고객센터로 문의해 주세요',
      cancelFeeNote:
        '차량이 배정된 후 승객이 임의로 취소할 경우, 취소 수수료가 부과됩니다',
      cny: '元',
      unit: 'JPY'
    },
    chat: {
      tips: {
        templateOnly: '다음의 템플릿 메시지만 사용할 수 있습니다',
        translation: '기사와 승객 간의 메시지는 상대방 언어로 자동 번역됩니다'
      }
    },
    hotelHome: {
      title: '택시 여행',
      wechatScan: {
        title: 'WeChat 스캔',
        description:
          '휴대폰으로 QR 코드를 스캔하여 WeChat 미니 프로그램에 접속하고 더 많은 서비스를 확인하세요'
      }
    },
    hotelDropOff: {
      title: '하차 지점 선택'
    },
    hotelOrderConfirm: {
      title: '주문 확인',
      unit: 'JPY',
      modify: '수정'
    },
    hotelPayment: {
      title: '요금 선결제',
      description: '아래 QR 코드를 휴대폰으로 스캔하여 결제해 주세요',
      money: '<span>JPY</span>{{amount}}',
      alertText:
        '원활한 배차를 위해 예상 요금 기준으로 미리 결제해 주세요. 탑승 종료 후 실제 요금 기준으로 정산되며, 초과 금액은 원결제 수단으로 환불되고 부족분은 추가로 결제됩니다.'
    },
    hotelPrePayTerms: {
      title: '선결제 약관',
      headDesc: `귀하는 "GOx 일본 여행 택시"(이하 "당사") 플랫폼의 사용자로 등록하셨으며, 플랫폼 규정에 따라 당사가 제공하는 이동 서비스를 이용하실 때 사전에 요금을 결제하셔야 할 수 있습니다. 이에 따라 본 선결제 약관(이하 "본 약관")을 체결합니다.본 서비스를 이용하시기 전에 본 약관의 내용을 충분히 읽고, 이해한 후 동의해 주시기 바랍니다. 미성년자의 경우, 법정 보호자의 동반 하에 본 약관을 읽고 동의해야 합니다.귀하가 "동의" 버튼을 클릭하거나 본 서비스를 이용하는 경우, 본 약관의 모든 내용을 읽고 이해하였으며, 이를 수락하고 관련 의무를 이행하며 이에 따른 책임을 질 것에 동의한 것으로 간주됩니다.`,
      content: [
        {
          title: '선결제 이용 약관',
          content: [
            '택시 서비스를 보다 편리하게 이용하실 수 있도록, 당사는 선결제 방식의 결제 수단을 제공합니다. 탑승 시작 전, 고객님은 플랫폼에서 안내된 예상 요금에 따라 차량 요금을 미리 결제하셔야 합니다.',
            '선결제 금액은 고객님이 선택하거나 예약한 이동 조건을 기준으로, 플랫폼에 고지된 요금 산정 규칙에 따라 산출됩니다. 이 금액은 실제 서비스를 이용하신 후, 해당 요금에서 차감되어 적용됩니다.',
            '이동 일정을 확정하고 선결제 완료 시, 주문은 정식으로 유효해집니다. 선결제가 이루어지지 않으면 주문을 제출할 수 없으며, 당사 플랫폼 내의 운전기사 서비스를 이용하실 수 없습니다.'
          ]
        },
        {
          title: '선결제 정산 및 조정',
          content: [
            '선결제 금액은 택시 주문 요금 결제에만 사용되며, 충전 또는 예치금으로 간주되지 않습니다.',
            '주문이 유효화되고 탑승이 완료된 후, 시스템은 실제 이용 요금에 따라 정산을 진행하며, “초과 시 환불, 부족 시 추가 결제” 원칙에 따라 처리됩니다.',
            '* 선결제 금액이 실제 요금을 초과한 경우, 잔액은 탑승 종료 후 원래 결제 수단으로 환불되며, 환불 소요 시간은 은행 또는 제3자 결제기관의 처리 기준에 따라 달라질 수 있습니다.',
            '* 선결제 금액이 실제 요금에 미치지 못하는 경우, 부족한 금액을 추가 결제하셔야 하며, 결제가 완료되어야 플랫폼 서비스를 계속 이용하실 수 있습니다.'
          ]
        },
        {
          title: '주문 취소 및 환불 안내',
          content: [
            '선결제를 완료하고 주문이 생성된 후, 고객의 개인 사유가 아닌 사정(예: 주문 미수락, 천재지변 등)으로 인해 운행이 이뤄지지 못한 경우, 선결제 금액은 전액 환불되며, 환불은 원결제 수단을 통해 진행됩니다.',
            '고객이 주문 생성 후 직접 취소하고, 해당 취소가 ‘귀책 취소’로 판단될 경우, 플랫폼은 관련 요금 규정에 따라 일부 금액을 공제한 뒤 나머지 금액을 환불합니다.',
            '환불 소요 기간은 결제 수단(은행 또는 제3자 결제 기관)의 처리 기준에 따라 달라지며, 일반적으로 영업일 기준 7일 이내에 완료됩니다. 환불에 문제가 발생할 경우, 플랫폼 고객센터로 문의해 주시면 결제 기관과의 조율을 도와드리겠습니다.'
          ]
        },
        {
          title: '적용 법률 및 분쟁 해결',
          content: [
            '본 약관은 『GOx 일본 여행 택시 사용자 약관』의 일부를 구성하며, 명시되지 않은 사항은 사용자 약관을 따릅니다. 본 약관은 사용자 약관, 개인정보처리방침 등과 함께 본 서비스의 법적 근거를 이룹니다. 본 약관과 다른 관련 문서 간에 내용이 상충되는 경우, 본 약관의 내용을 우선으로 적용합니다.',
            '본 약관은 일본 법률을 적용하며, 본 약관으로 인해 발생하는 분쟁에 대해서는 우선적으로 쌍방 간의 협의를 통해 원만히 해결하도록 합니다. 협의가 이루어지지 않을 경우, 관할 법원에 소송을 제기할 수 있습니다.'
          ]
        },
        {
          title: '기타 조항',
          content: [
            '본 약관의 일부 조항이 언제든지 불법이거나 무효, 또는 집행 불가능하다고 판단되더라도, 전체 약관의 효력에 영향을 미치지 않는 한, 나머지 조항은 여전히 유효하게 적용됩니다. 당사는 관련 조항을 합리적으로 조정하여, 적용 법률에 부합하도록 수정할 권리를 가집니다.',
            '또한, 당사는 본 약관에 대한 최종 해석권을 보유하며, 사업 운영상 필요에 따라 약관 내용을 수시로 개정할 수 있습니다. 개정된 약관은 플랫폼을 통해 공지되며, 사용자가 서비스를 계속 이용하는 경우 개정된 약관에 동의한 것으로 간주됩니다.'
          ]
        }
      ]
    },
    hotelPayResult: {
      success: {
        title: '결제 성공',
        description: '화면을 전환 중입니다'
      },
      fail: {
        title: '결제 실패',
        subtitle: '다시 주문을 시도해 주세요',
        description: '네트워크 연결 상태나 카드 잔액 등을 확인해 주세요',
        btnText: '택시 호출 페이지로 돌아가기',
        seconds: '{{amount}}s'
      }
    },
    hotelOrderDetail: {
      requestSuccess: '택시를 불렀습니다'
    },
    login: {
      title: '로그인/회원가입',
      content: {
        title: '로그인/회원가입 방법을 선택해 주세요',
        description:
          '*서드파티 계정으로 간편하게 로그인 및 회원가입이 가능합니다',
        agreement:
          '*이메일 또는 서드파티 계정으로 로그인하시면 관련<terms>{{terms}}</terms>과<privacy>{{privacy}}</privacy>',
        terms: '이용약관',
        privacy: '개인정보처리방침'
      },
      button: {
        google: 'Google',
        email: 'Email',
        nextStep: '다음 단계',
        signIn: '회원가입'
      },
      email: {
        label: '이메일'
      }
    },
    couponList: {
      title: '쿠폰',
      tabs: {
        inputCode: '쿠폰 코드 입력',
        shareCoupon: '쿠폰 코드 공유'
      },
      inputPlaceholder: '쿠폰 코드를 입력하세요',
      condition: '총 예상 요금이 JPY{{amount}}를 초과할 때 사용 가능',
      applyTo: '프리미엄 택시에 적용',
      validUntil: '유효기간',
      minSpend: 'JPY{{amount}} 이상 사용 가능',
      maxDiscount: '최대 JPY{{amount}} 할인',
      noMinSpend: '최소 사용 금액 없음',
      useButton: '사용하기',
      validDate: '{{start}}부터 {{end}}까지 사용 가능',
      empty: '쿠폰이 없습니다',
      emptyTip: '쿠폰을 받으러 가세요',
      couponType: {
        NEW_USER: '신규 회원 할인 쿠폰',
        SHARE: '초대 쿠폰',
        SHARE_REWARD: '초대 리워드 쿠폰',
        BUNDLE: '번들 쿠폰',
        PROMOTION: '기간 한정 쿠폰',
        AIRPORT_COUPON: '공항 정액 할인 쿠폰',
        UNKNOWN_COUPON_TYPE: '알 수 없는 쿠폰'
      }
    },
    showDialog: {
      title: '초대 코드 공유하고 함께 혜택 받기！',
      description:
        '친구 초대 쿠폰은 "쿠폰 지갑 보기"를 클릭하여 초대·교환으로 <span>고액 쿠폰</span> 받기',
      rideButton: '지금 탑승',
      shareButton: '초대 코드 공유'
    },
    shareCoupon: {
      title: '초대 코드 공유',
      headline: '친구를 초대하여 함께 승차 할인을 즐기세요!',
      description:
        '친구를 초대하여 성공적으로 등록하면, 친구는 9.5할인 쿠폰(최대 500엔까지)을 받을 수 있습니다. 첫 승차 완료 후, 당신은 200엔 쿠폰(7일 유효)을 받을 수 있습니다. 초대 횟수 제한 없음',
      description2:
        '친구가 귀하의 전용 쿠폰 코드를 입력하면 친구는 <span>2000엔 즉시 할인 쿠폰</span>을 받을 수 있습니다. 친구가 승차한 후에는 귀하도 <span>1000엔 즉시 할인 쿠폰</span>을 받을 수 있습니다! 쿠폰 지갑에 자동으로 발급되며, 수령 후 15일 이내 유효합니다. 여러 명 초대 가능, 친구와 함께 GO!',
      campaignDate: '(본 캠페인은 2026년 10월 12일까지, 선착순 2000명 한정)',
      linkLabel: '초대 링크',
      inviteCodeLabel: '전용 초대 코드',
      copyButton: '복사',
      copySuccess: '복사 성공',
      copyFailed: '복사 실패'
    },
    redeemCoupon: {
      title: '쿠폰 코드 입력',
      codeLabel: '쿠폰 코드',
      placeholder: '쿠폰 코드를 입력하세요',
      confirmButton: '교환 확인',
      instruction1:
        '*쿠폰 교환 코드를 입력하고 [교환 확인]을 클릭하여 교환을 완료하세요;',
      instruction2:
        '*각 교환 코드는 한 번만 성공적으로 교환할 수 있습니다. 교환 성공 후 유효 기간 내에 사용하세요. 만료되면 무효화됩니다.',
      emptyCode: '쿠폰 코드를 입력하세요',
      redeemSuccess: '교환 성공',
      redeemFailed: '교환에 실패했습니다. 나중에 다시 시도해주세요'
    },
    getCoupon: {
      title: '쿠폰 받기',
      coupon: {
        title: '신규 회원 할인 쿠폰',
        validity: '유효기간: {{validity}}까지',
        discount: '{{value}}%<unit>할인</unit>',
        minimumSpend: 'JPY{{amount}} 이상 사용 가능',
        usageCondition: '총 예상 요금이 JPY{{amount}}을 초과할 때 사용 가능'
      },
      button: {
        claim: '지금 받기'
      },
      terms: {
        itema:
          '*최초 등록하고 아직 택시를 이용하지 않은 사용자만 받을 수 있습니다',
        itemb:
          '*로그인 후에만 받을 수 있으며, 만료되었거나 로그인하지 않은 경우 받을 수 없습니다. 스캔당 한 번만 받을 수 있습니다',
        itemc:
          '*받기 성공 후, 내 쿠폰함에 들어가서 확인하고 사용할 수 있습니다',
        itemd: '*7일 이내에 사용해야 하며, 만료 후 무효화됩니다'
      },
      success: {
        title: '받기 성공',
        description:
          '쿠폰이 성공적으로 쿠폰 지갑에 추가되었습니다. 내 쿠폰 지갑에 들어가서 확인하고 사용할 수 있습니다',
        viewButton: '쿠폰 확인',
        gotItButton: '알겠습니다'
      },
      newComer: {
        title: '축하합니다! 혜택을 받았습니다!',
        description:
          '친구 초대 쿠폰은 "쿠폰 지갑 보기"를 눌러 초대 코드를 공유하거나, 쿠폰 코드를 입력해 교환하세요.',
        rideButton: '지금 탑승',
        viewButton: '쿠폰 지갑 보기',
        coupon: {
          discountUnit: '{{value}}%<unit>할인</unit>',
          jpyUnit: '<unit>JPY</unit>{{value}}',
          maxDiscount: '최대 JPY{{amount}} 할인',
          validity: '{{validity}}까지 유효'
        }
      }
    },
    signIn: {
      register: '회원가입',
      login: '로그인',
      email: {
        label: '이메일'
      },
      password: {
        label: '비밀번호'
      },
      button: {
        register: '회원가입',
        signIn: '로그인'
      },
      forgetPassword: '비밀번호를 잊으셨나요?',
      validate: {
        email: {
          invalid: '올바른 이메일 주소를 입력해 주세요'
        },
        password: {
          required: '비밀번호를 입력해 주세요'
        }
      }
    },
    reset: {
      title: '비밀번호를 리셋',
      email: {
        label: '이메일'
      },
      button: {
        reset: '메일로 비밀번호를 리셋',
        backToSignIn: '로그인으로 돌아가기'
      },
      sendResetEmailSuccess:
        '비밀번호 재설정 링크가 <email>{{email}}</email> 에 전송되었습니다. 이메일을 확인하고 비밀번호를 재설정해 주세요.'
    },
    terms: {
      name: 'Terms of Use',
      title: 'LINKTIVITY Terms of Use',
      lastUpdated: 'Last Updated: May 1, 2020',
      subtitle: `LINKTIVITY Terms of Use
LINKTIVITY Corporation (hereinafter referred to as "our company") has established the following LINKTIVITY Terms of Use (hereinafter referred to as "this agreement") for the use of LINKTIVITY services.

By using LINKTIVITY services, you acknowledge that you have agreed to accept the contents of this agreement. Please read this agreement carefully when using LINKTIVITY services. Additionally, this agreement may be modified as needed, so please refer to the latest content when using LINKTIVITY services.

* For information regarding the handling of personal information, please read the "Personal Information Protection Policy."`,
      content: [
        {
          title: 'Article 1 Purpose',
          content:
            'This agreement applies to users of the services of "LINKTIVITY," a platform sales website for venue rentals operated by our company. Users of this service must agree to this agreement in advance and use this service based on compliance with this agreement. This agreement may also be modified without prior notice.'
        },
        {
          title: 'Article 2 Member Registration',
          content: `1. "Member" refers to an individual who has been approved by our company to become a member. Such individual, upon agreeing to this agreement, accepting and completing the member registration procedures specified by our company, obtains this service according to these terms. However, even after approval, if our company deems the member inappropriate, approval may be revoked.
2. Information provided during member registration should be true, accurate, and valid. Individual, registration information (such as name, email address, etc.), and passwords should correspond one-to-one, and the same person should not register multiple member identities.
3. If registration information changes, members must immediately perform the prescribed change procedures.`
        },
        {
          title: 'Article 3 Information Provided by Product Suppliers',
          content:
            'Our company provides members with content, fees, available purchase dates, cancellation provisions (cancellation policies), and other purchase-related information (hereinafter referred to as "purchase-related information") provided by product suppliers on LINKTIVITY, as well as product supplier-related information. Purchase-related information is the responsibility of product suppliers, and unless our company fails to transmit information due to intentional acts or negligence, our company bears no responsibility for the content of purchase-related information.'
        },
        {
          title: 'Article 4 Contract Formation',
          content:
            'On the LINKTIVITY platform, contracts related to products purchased and services provided by members will be concluded between members and product suppliers. Posting products, services, and other content on LINKTIVITY is only for the purpose of submitting applications to product suppliers, and our company has the right to freely approve or reject such applications on behalf of product suppliers. This agreement stipulates the conditions for members to use LINKTIVITY services, including cases where members submit purchase applications to product suppliers using LINKTIVITY. However, member reservations for products and services must follow the contract conditions displayed by LINKTIVITY, information provided during the reservation process, and conditions stipulated by legal contracts related to products and services as stipulated by product suppliers.'
        },
        {
          title: 'Article 5 Fee Payment',
          content: `LINKTIVITY, as a collection agent for product suppliers, obtains payment information from members and processes payments. Members should pay fees to our company through credit cards or payment methods provided by our company when purchasing products and services. If expressed in foreign currency, our company will convert the credit card payment amount or settlement amount of payment methods provided by our company to yen according to the determined exchange rate.

However, some payments should be made through one or more methods specified on the page.`
        },
        {
          title:
            'Article 6 Content and Quality of Products and Services Provided by Product Suppliers',
          content:
            'Our company is not responsible for the content and quality of products and services provided by product suppliers. Any problems, disputes, or complaints arising between members and product suppliers, as well as any losses suffered by members, should be resolved through consultation with product suppliers, and our company bears no responsibility for this.'
        },
        {
          title: 'Article 7 Usage Environment',
          content: `1. When using LINKTIVITY, members should prepare necessary communication equipment, software, communication means, and other products and services on their own, and bear full responsibility and costs incurred during the period.
2. When using LINKTIVITY, members should prepare necessary smartphones, software, communication means, and other products and services that can connect to the network on their own, and bear full responsibility and costs incurred during the period.`
        },
        {
          title:
            'Article 8 Order Cancellation and Cancellation Fees Due to Member Reasons',
          content: `1. Cancellation fees incurred when members cancel orders due to their own reasons will be charged according to the cancellation terms (cancellation policies) stipulated by product suppliers.
2. Our company bears no responsibility for foreign exchange gains and losses caused during payment and refund.
3. In principle, members need to log into the "Personal Page" of LINKTIVITY and cancel reservations. However, if they contact product suppliers before the usage date and product suppliers accept order cancellation, cancellation procedures can be completed by notifying LINKTIVITY through the "Personal Page" later.`
        },
        {
          title:
            'Article 9 Order Cancellation and Refunds Due to Product Suppliers',
          content:
            'When product suppliers change or cancel products and services, they should directly notify members, and our company bears no responsibility for changes or cancellations of products and services. However, according to decisions or requirements of product suppliers, if the content of sold products or services changes or is cancelled, our company may handle refunds for products or services on their behalf.'
        },
        {
          title: 'Article 10 Password Management',
          content: `1. Members are responsible for and should manage passwords.
2. Members should not provide email addresses and passwords to third parties for use, and should not lend, transfer, rename, sell, mortgage, etc.
3. Damage liability caused by improper password management, usage errors, or third-party usage by members is borne by members themselves, and our company bears no responsibility.`
        },
        {
          title: 'Article 11 Handling of Member Registration Information',
          content: `1. During member registration, personal information provided by members (hereinafter referred to as "registration information") will be managed and stored by our company according to our company's personal information protection policy.
2. Our company will not disclose to third parties information containing personally identifiable information (hereinafter referred to as "personal information"). However, the following cases are excluded:

   i. When disclosing information with customer consent

   ii. When providing personal information necessary for service performance to business outsourcing companies that have signed personal information protection confidentiality agreements

   iii. When conducting statistical analysis of personal information for service improvement and disclosing or providing to third parties in a state where personal identity cannot be identified or determined

   iv. When disclosure is required according to search warrants issued by courts or court judgments

Additionally, please read the "Personal Information Protection Policy" to understand the personal information obtained by our company, usage purposes, and processing details.`
        },
        {
          title: 'Article 12 Prohibited Items for Members',
          content: `When using LINKTIVITY, members should not engage in the following behaviors or behaviors that may lead to the following:

1. Behaviors that violate this agreement
2. Behaviors that violate public order and morals or laws and regulations
3. Behaviors that infringe on copyrights, portrait rights, or other intellectual property rights of our company, other members, or third parties
4. Behaviors that defame or slander other members or third parties
5. Behaviors that bring adverse effects to other members or third parties
6. Behaviors that interfere with our company's business or hinder our company's service operations
7. Profit-making behaviors
8. Behaviors of transferring or lending rights obtained as members to third parties without prior consent of our company
9. Other behaviors that our company deems inappropriate`
        },
        {
          title:
            'Article 13 Deletion or Correction of Information Sent by Members',
          content: `Our company may delete part or all of the information sent by members that conforms to or may belong to any of the following items, or make any corrections that our company deems necessary, without member consent:

1. Information that our company deems to conform to the "Member Prohibited Items" of this agreement
2. Information that our company judges to be inconsistent with facts
3. Other situations that our company deems inappropriate`
        },
        {
          title: 'Article 14 Cancellation of Member Status',
          content: `If members fall under any of the following situations, our company may cancel member status without prior notice to members, and bears no responsibility to members:

1. One of the situations that violate the "Member Prohibited Items" of this agreement
2. Other violations of this agreement
3. Other situations where our company deems the member unsuitable for member status`
        },
        {
          title: 'Article 15 Service Changes, Suspension, and Termination',
          content: `1. Our company may change, suspend, or terminate service content without prior notice to members.
2. When any disadvantages or losses are caused to members due to changes, suspension, or termination of this service content, our company bears no responsibility.
3. Our company may notify members one month in advance and terminate service provision.`
        },
        {
          title: 'Article 16 Copyright and Property Rights',
          content:
            'All content displayed on LINKTIVITY is copyrighted and owned by our company and individuals or entities such as product suppliers, partners, and advertisers who provide such content to our company. Unless prior written consent is obtained from our company, product suppliers, partners, and advertisers, users and members agree not to copy, disclose, transfer, lend, translate, reprint, transmit, use, or reuse such content. Additionally, our company has the right to claim compensation from users and members for amounts equivalent to benefits obtained during the above-mentioned behaviors.'
        },
        {
          title: 'Article 17 Disclaimer and Liability Limitation',
          content: `1. Our company bears no responsibility for any damages occurring between our company and product suppliers, any damages caused by members violating this agreement, or damages caused by non-company reasons during product or service exchange processes.
2. Product suppliers are independent contract entities from our company. Our company bears no responsibility for any damages or other damages caused by injuries, deaths, property losses, theft, or terrorist attacks when members participate in product activities or enjoy services due to behaviors, negligence, omissions, agency behaviors, guarantees, etc. of product suppliers.
3. Our company bears no responsibility for events such as delays, cancellations, duplicate purchases, strikes, etc. of products or services beyond our company's direct management scope. Additionally, when content changes, cancellations, delays, additional costs, etc. occur due to government agencies, court orders, etc., our company bears no response obligations.
4. When our company provides this service, if members directly or indirectly suffer losses beyond actual, ordinary losses, even if our company has intentional or negligent acts, our company bears no responsibility.`
        },
        {
          title: 'Article 18 Changes to This Agreement',
          content:
            'Our company reserves the right to change the content of this agreement when necessary. When modifying this agreement, changes are considered completed by simply making modifications on this page, and members will not be notified individually.'
        },
        {
          title: 'Article 19 Jurisdiction',
          content:
            'For any disputes regarding this agreement, the Tokyo District Court will be the exclusive court of first instance.'
        },
        {
          title: 'Article 20 Consultation',
          content:
            'For matters not stipulated in this agreement or any questions about this agreement, both parties should negotiate in good faith and make friendly efforts to find solutions together.'
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          content: ''
        }
      ]
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: March 18, 2022',
      company: 'LINKTIVITY Corporation',
      contentTitle: 'Personal Information Protection Policy',
      subTitle:
        "Our company collects users' personal information through LINKTIVITY, a reservation website operated by our company. Our company believes that protecting users' personal information is very important to allow users to book products with peace of mind and convenience, so our company handles personal information by complying with the following provisions:",
      content: [
        {
          title: 'Manager of User Personal Information',
          content:
            'LINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo'
        },
        {
          title: 'Information Collection',
          content:
            "Except in cases required by law, our company collects the minimum necessary personal information from users after obtaining their consent to achieve our company's usage purposes."
        },
        {
          title: 'Information Usage',
          content:
            'Our company only uses personal information collected from users when achieving the usage purposes stipulated by our company.'
        },
        {
          title: 'Storage and Preservation',
          content:
            'Our company performs storage and preservation work on personal information to ensure that personal information obtained from users does not leak, and ensures system security.'
        },
        {
          title: 'Destruction and Deletion',
          content:
            'When personal data (referring to personal information stipulated by the Personal Information Protection Law, the same applies hereinafter) is no longer needed for use, our company will destroy it promptly.'
        },
        {
          title: 'User Consultation and Other Processing',
          content:
            'For user requests to inform usage purposes, disclosure requests, correction/addition/deletion requests, stop usage/deletion requests, and stop provision to third parties, our company will process them according to legal requirements.'
        },
        {
          title: 'Security Management Measures and Others',
          content:
            'Our company will educate all employees related to LINKTIVITY services to understand the importance of personal information and take necessary and appropriate measures to manage the security of personal information.'
        }
      ],
      rules: [
        {
          title:
            '1. Personal Information Obtained by Our Company and Its Usage Purposes',
          subtitle:
            "Our company will collect and use users' personal information such as address, name, date of birth, contact information, email address, or passport number for the following purposes. Additionally, without user consent, our company will not collect personal information that requires special attention. When collecting personal information from users, if the personal information usage purpose is not publicly disclosed, the personal information usage purpose should be informed to users or publicly displayed. Furthermore, without parental consent, our company will not collect personal information from children under 13 years old. When our company collects personal information from children under 13 years old, it will be deemed that guardian consent has been obtained, but if there is clearly no consent, our company will not use that personal information for purposes other than contacting guardians.",
          rule: [
            {
              title:
                'i. LINKTIVITY Service Usage (Member Registration, etc.) Purpose',
              content:
                'To use LINKTIVITY services, our company will share user personal information within the company.\nLegal basis: Necessary to provide services or functions requested by users.'
            },
            {
              title: 'ii. Ticket Purchase Application',
              list: [
                {
                  title: 'Personal Information Collection Items',
                  content:
                    "When users apply to product suppliers to purchase tickets, our company will collect users' names, payment information, passport numbers, and information related to users' health conditions, etc."
                },
                {
                  title: 'Specific Usage Purposes',
                  content:
                    "Our company will collect users' personal information to confirm users' ticket purchase eligibility and payment matters. Additionally, to achieve this purpose, our company will provide users' personal information to product suppliers, transportation agencies, payment settlement providers (including overseas providers, etc.), etc."
                }
              ],
              subtitle:
                "Legal basis: To meet users' service needs and provide necessary functions."
            },
            {
              title:
                'iii. To send notifications to users, including newsletters (email magazines, etc.), our company will collect personal information after user consent',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title:
                'iv. Advertising delivery through social media and advertising platforms',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title: 'v. To request questionnaire completion',
              content:
                "Legal basis: Collecting personal information based on user consent to improve our company's reservation website, products, services, and other content."
            },
            {
              title: 'vi. To analyze and manage user information',
              content:
                "Legal basis: To pursue and protect users' legitimate interests by improving our company's reservation website, products, services, and other content."
            },
            {
              title: 'vii. To detect unauthorized use of credit cards, etc.',
              content:
                "Legal basis: Necessary to ensure the security of users' credit cards to pursue and protect users' legitimate interests."
            }
          ]
        },
        {
          title: '2. Third-Party Provision of Personal Information',
          subtitle:
            "Our company will not provide users' personal information obtained to third parties, except in the following cases:\n\ni. When users provide personal information to third parties (including product suppliers, overseas travel agencies, social media operators, advertising service companies, and other businesses). When users have previously agreed to provide personal information to third parties through consent to this privacy policy or other means.\nii. When entrusting external organizations to process personal information within the necessary scope.\niii. When providing personal information is required by law.\niv. When it is necessary to protect an individual's life, body, or property and user consent cannot be obtained.\nv. When it is particularly necessary to improve public health or promote healthy child development and user consent cannot be obtained.\nvi. When cooperating with national and local governments to execute legal affairs, and obtaining user consent may affect the execution of those affairs.",
          rule: []
        },
        {
          title: '3. Entrustment of Personal Information Processing',
          subtitle:
            "When the company, in necessary cases, entrusts users' personal information to third parties based on the above provisions, it will provide necessary and appropriate supervision to the entrusted party to achieve the company's purposes. If the entrusted party re-entrusts, the company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same applies to cases of re-re-entrustment.\nIf our company, according to the above provisions, entrusts users' personal information to third parties within the necessary scope to achieve our company's usage purposes, our company will provide necessary and appropriate supervision to the entrusted party. Additionally, if the entrusted party re-entrusts data, our company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same should apply to cases where the re-entrusted party re-entrusts.",
          rule: []
        },
        {
          title: '4. Obtaining Cookie Information, etc.',
          rule: [
            {
              title: 'i. Cookies',
              content:
                "Cookies are pieces of data stored on users' hard drives containing information about users. Our company does not use cookies as personal identification information. Additionally, since they are temporary cookies, once users close their browsers, cookies will not be saved. Our company uses cookies to improve service quality, customize our company's website, and measure advertising effectiveness.\nAdditionally, our company analyzes cookies as statistical data to detect users' interests and concerns and prevent unauthorized access.\nUsers can disable cookies according to their needs, but this will prevent users from making reservations on LINKTIVITY."
            },
            {
              title: 'ii. Logs/Files',
              content:
                'Our company automatically collects specific information and saves it in log files. This specific information includes IP (Internet Protocol) addresses, browser types, ISP (Internet Service Provider), referrer/exit pages, operating systems, date/time stamps, etc. Our company uses this information to monitor unauthorized access. Additionally, our company conducts user trend analysis, website management, and user behavior tracking.\nHowever, when using the above information, our company ensures that specific individuals are not identified and that the obtained information is not used for any purposes other than those mentioned above.'
            },
            {
              title: 'iii. Web Beacons',
              content:
                'Our company uses Web Beacons for access analysis and affiliate programs. Our company will not use Web Beacons for any purposes other than those mentioned above, nor will they be used to identify specific individuals.'
            },
            {
              title: 'iv. Statistical Analysis',
              content:
                "Our company uses third-party access analysis tools to confirm which websites and services are popular and record users' access pages and page history within the LINKTIVITY website.\nOur company uses this data to provide LINKTIVITY content and advertisements that match the interests of users interested in specific areas.\nAdditionally, our company may collect statistical information unrelated to personal identity. Furthermore, cookie information collected by our company and cookie information collected by other companies may be mutually viewed on third-party access analysis tools."
            }
          ]
        },
        {
          title: '5. Processing of Anonymized Information',
          rule: [
            {
              title: '1. Creation of Anonymized Information Processing:',
              content:
                'Our company will comply with the following provisions when creating anonymized information. Anonymized information processing refers to personal information-related information obtained by processing personal information, taking legally stipulated measures that cannot identify specific individuals and cannot restore the original personal information.\n\n1) Follow legally stipulated standards and perform appropriate processing;\n2) Take security measures according to legally stipulated standards to prevent leakage of deleted information or information processing methods;\n3) Publicly disclose information items that have been processed into anonymized information;\n4) Take no action to perform personal identification behavior.'
            },
            {
              title: '2. Provision of Anonymized Information',
              content:
                'If anonymized information is to be provided to third parties, our company should publicly disclose the personal information-related items in the anonymized information to be provided and the provision method, and clearly inform the third party receiving the information that it is anonymized information.'
            },
            {
              title: '3. Regarding Disclosure of Anonymized Information',
              content:
                'Regarding the creation of anonymized information\nFor the following users\' personal information, our company will continuously create anonymized information while taking appropriate measures to ensure that specific individuals cannot be identified and personal information cannot be restored.\n\nPersonal information-related items contained in anonymized information\nInformation obtained for providing platform services\nPurchase date, participation date, coupon language, sales price range, number of participants, reservation status (confirmed reservation or cancellation, etc.), supplier location area and prefecture information, travel agency country/region\n\nProvision of anonymized information to third parties\nFor anonymized information created or held by our company, our company will continuously provide it to third parties after clearly indicating that it is anonymized information.\n\nPersonal information-related items contained in anonymized information\nSame items as "Personal information-related items contained in anonymized information" in "Regarding the creation of anonymized information" above\n\nProvision method\nSend password-protected electronic files through electronic communication methods (email, server upload, API links, etc.) or physical media such as DVDs.'
            }
          ]
        },
        {
          title: '6. Security Management Measures for Personal Information',
          subtitle:
            'To prevent personal information leakage, theft, misuse, unauthorized access, tampering, and destruction, our company has implemented organizational, technical, and physical security management measures. Access to servers storing personal information by our company is limited to specific employees holding ID/PW, and particularly for certain personal information management, only the minimum number of employees required for data management are allowed access.\n\nAdditionally, personal information including credit card information is distributed across multiple data centers and stored in secure environments. We also use Secure Socket Layer (SSL) encryption on all reservation transaction pages. By using SSL-enabled browsers, you can keep personal information and credit card information transmitted over the Internet confidential.\n\nAdditionally, employees handling user personal information will use password-protected screen savers when leaving terminals.\n\nFurthermore, our company conducts education and training on the importance of personal information and other matters once a month for some departments and at least once every six months for the entire company, and retains education records.',
          rule: []
        },
        {
          title: '7. Rights Regarding User Personal Information Processing',
          subtitle:
            'According to the EU General Data Protection Regulation (GDPR) 2016/679 effective from April 27, 2016, regarding the processing of personal information, users have the following rights:',
          rule: [
            {
              title: 'i. Right of Access'
            },
            {
              title: 'ii. Right of Rectification'
            },
            {
              title:
                'iii. Right to Erasure (Right to be Forgotten) and Right to Restrict Processing'
            },
            {
              title: 'iv. Right to Data Portability'
            },
            {
              title: 'v. Right to Object'
            },
            {
              title:
                'vi. Right not to be Subject to Decisions Based on Automated Processing (Including Profiling).'
            }
          ]
        },
        {
          title:
            '8. Requests for Disclosure, Correction, Cessation of Use, etc.',
          subtitle:
            'Our company will respond to the following requests through the contact window listed in Article 11 below: usage purposes provided by users, disclosure requests, correction/addition/deletion requests, cessation of use, deletion requests, and suspension of provision to third parties of retained personal information (hereinafter collectively referred to as "disclosure requests, etc.").\n\nAdditionally, our company may also change and confirm member information on users\' personal pages and stop services such as email magazines according to user requests.',
          rule: []
        },
        {
          title: '9. External Links',
          subtitle:
            'The LINKTIVITY website contains links to other websites. This privacy policy only applies to information collected by the LINKTIVITY website, and our company bears no responsibility for the privacy policies or content of other websites. When users visit other linked websites, it is recommended to read their privacy policies and confirm how they handle personal information.',
          rule: []
        },
        {
          title: '10. Changes to Privacy Policy',
          subtitle:
            'Our company publishes the privacy policy on the LINKTIVITY website to enable users to know the purposes for which our company obtains and uses user personal information and what information our company collects. Additionally, if the privacy policy changes, it will also be published on the LINKTIVITY website to make it public to users.',
          rule: []
        },
        {
          title: '11. Contact Information',
          subtitle:
            "If you have questions about our company's privacy policy, personal information protection measures, collection and use of personal information, or requests for disclosure, etc., please contact us using the information below, and our company staff will respond within 5 business days.\n\nLINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo\n\nData Protection Officer Contact: dpo@linktivity.co.jp",
          rule: []
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          rule: []
        }
      ]
    },
    service: {
      title: '도움말',
      categories: {
        fee: '비용에 대하여',
        driver: '기사에 대하여',
        other: '기타'
      },
      items: {
        fee: {
          estimatedCost: {
            label: '예상 요금',
            content:
              '예상 요금은 대략적인 이동 비용을 확인하는 데 도움이 됩니다. 승하차 위치를 입력한 후 다음 페이지에서 예상 요금을 확인할 수 있습니다. 예상 요금은 최단 경로와 예상 주행 시간을 고려하여 계산된 최적의 가격입니다. 실제 요금은 교통 상황, 날씨, 도로 공사, 경로 변경 등 다양한 요인에 따라 달라질 수 있습니다. 참고하세요: 예상 요금은 주문 시점에만 유효합니다. 통행료나 공항 이용료 등 추가 요금은 예상 요금에 포함되지 않습니다. 이 요금은 단순한 예상치이며, 실제 요금이 예상 요금보다 높을 수 있음을 보장할 수 없습니다.'
          },
          costBreakdown: {
            label: '요금 내역',
            content:
              '귀하의 이동 요금은 여러 요소를 종합하여 계산되며, 지역 및 차량 제공 업체에 따라 다를 수 있습니다. 요금 계산 시 주로 고려되는 세 가지 요소는 다음과 같습니다. 1. 기본 요금 2. 거리 요금(이동 거리) 3. 시간 요금(이동 시간) 실제 요금에 영향을 미칠 수 있는 다른 요인: 1. 실시간 요금(예: 피크 시간대 요금) 2. 통행료 및 공항 이용료 3. 차량 종류 4. 미니프로그램 서비스 요금 실제 청구 금액이 예상 요금과 다르다면 "실제 요금이 예상 요금보다 높은 경우" 항목을 참고해 주세요. 참고하세요: 전자 영수증에는 현재 요금 내역이 표시되지 않습니다. 이동이 끝난 후, 차량 제공 업체에서 계산한 실제 요금이 발송됩니다. 미니프로그램을 이용하는 즉시, 화면에 표시된 가격을 수락한 것으로 간주되며, 청구된 금액이 실제 이동 요금으로 확정됩니다. 실제 요금은 택시 미터기 요금과 다를 수 있습니다.'
          },
          additionalFees: {
            label: '통행료, 공항 이용료 등 추가 요금',
            content:
              '공항 이용료, 고속도로 통행료 등 추가 요금은 예상 요금에 포함되지 않으며, 모든 추가 요금은 승객이 부담해야 합니다. 다만, 일부 경우 운전자가 이동 종료 전에 이러한 요금을 실제 요금에 추가할 수 있습니다.'
          },
          cancellationFees: {
            label: '취소 수수료',
            content:
              '운전자의 공차 이동 거리와 시간을 보상하기 위해, 다음 두 가지 상황에서 주문을 취소하면 취소 수수료가 부과될 수 있습니다. 1. 운전자가 주문을 수락하고 일정 시간 또는 거리를 이동한 경우. 2. 운전자가 승차 위치에 도착하여 일정 시간 이상 대기한 경우. 이 경우 운전자가 주문을 취소하더라도 취소 수수료가 청구됩니다. 취소 수수료는 차량 제공 업체의 효율적인 운영과 더 빠른 배차를 보장하기 위해 필요합니다. 취소 수수료는 지역 및 차량 제공 업체에 따라 다를 수 있습니다. 요금이 부당하다고 생각되면 "고객센터 문의" 버튼을 통해 고객센터로 연락해 주시면 최대한 도움을 드리겠습니다.'
          },
          actualCostHigher: {
            label: '실제 요금이 예상 요금보다 높은 경우',
            content:
              '주문 전에 제시된 요금은 예상치일 뿐이며, 실제 요금이 예상 요금보다 높지 않음을 보장할 수 없습니다. 실제 요금이 예상보다 높은 이유는 다음과 같을 수 있습니다: 1. 교통 체증 2. 추가 요금(통행료, 공항 이용료 등) 3. 이동 중 추가 정차 4. 운전자가 다른 경로를 선택한 경우 5. 내비게이션 또는 네트워크 문제 실제 요금에 대해 의문이 있으시면 "고객센터 문의" 버튼을 통해 고객센터로 연락해 주시면 최대한 도움을 드리겠습니다.'
          },
          vehicleDamage: {
            label: '차량 손상 및 청소 요금',
            content:
              '승객이 차량을 더럽힌 경우 청소 비용을 부담해야 합니다. 이 경우 운전자는 실제 요금에 청소 비용을 추가할 권리가 있습니다. 해당 비용은 차량 청소를 위해 운전자에게 직접 지급됩니다. 승객은 차량 내에서 음식이나 음료를 섭취하지 말고 차량을 깨끗하게 유지해 주시기 바랍니다.'
          }
        },
        driver: {
          longerRoute: {
            label: '운전자가 더 긴 경로를 선택한 경우',
            content:
              '운전자는 내비게이션에서 추천하는 가장 빠른 경로나 최단 경로를 선택할 권리가 있습니다. 이동 종료 시 실제 요금이 예상보다 높을 경우, 이는 운전자가 교통 체증이나 도로 상황을 피하기 위해 더 긴 경로를 선택했기 때문일 수 있습니다. 선호하는 경로가 있다면 출발 전에 운전자와 미리 협의하시기 바랍니다. 실제 요금이 예상보다 현저히 높은 경우 "고객센터 문의" 버튼을 통해 고객센터로 연락해 주시면 최대한 도움을 드리겠습니다.'
          },
          orderNotEnded: {
            label: '하차 후 운전자가 주문을 종료하지 않은 경우',
            content:
              '운전자는 승객이 하차할 때 또는 직후에 주문을 종료해야 합니다. 운전자가 주문을 제때 종료하지 않아 실제 요금이 예상보다 현저히 높아진 경우, "고객센터 문의" 버튼을 통해 고객센터로 연락해 주시면 최대한 도움을 드리겠습니다.'
          }
        },
        other: {
          lostItems: {
            label: '분실물',
            content:
              '분실물에 대한 승객님의 급한 마음을 충분히 이해하며, 최대한 물품을 찾을 수 있도록 도와드리겠습니다. 아래의 "고객센터 문의" 버튼을 클릭하여 고객센터로 연락해 주시고, 다음 정보를 제공해 주세요: 1. 분실한 물품에 대한 상세 설명 2. 물품이 발견되었을 경우 원하는 수령 장소 3. 연락 가능한 전화번호 (물품을 찾은 경우 즉시 연락드릴 수 있도록) 4. 해당 지역에 머무르는 기간 위 정보를 제공해 주시면, 차량 제공 업체와 즉시 연락하여 최대한 물품을 찾을 수 있도록 도와드리겠습니다. 단, 개인정보 보호법에 따라 운전자의 연락처는 제공되지 않습니다. 참고하세요: 저희는 분실물 반환을 위해 최선을 다하지만, 이동 중 발생한 분실물에 대해 책임을 지지 않습니다.'
          },
          otherIssues: {
            label: '기타 문제',
            content:
              '주문이나 서비스와 관련하여 다른 문제나 제안이 있으시면 아래의 "고객센터 문의" 버튼을 통해 고객센터로 연락해 주시면 최대한 도움을 드리겠습니다.'
          }
        }
      },
      contact: '고감센터 문의'
    }
  },
  cancelTerms: {
    title: '취소 규칙',
    textTitle: 'GOx 일본 택시 취소 규칙',
    content: [
      {
        title: '취소 수수료 설명',
        content: [
          '운전자가 주문을 받은 후 3분 이상 경과하거나 이미 승차 지점에 도착한 경우, 주문을 취소하면 공급업체가 취소 수수료를 청구할 수 있습니다.',
          '다른 공급업체의 취소 수수료 규칙에 차이가 있을 수 있으므로, 구체적인 수수료 기준은 공급업체가 제공하는 정보를 참조하시기 바랍니다.'
        ]
      },
      {
        title: '취소 수수료 용도',
        content: [
          '플랫폼이 징수하는 취소 수수료는 여행 취소로 인해 발생하는 빈주행 비용을 운전자에게 보상하고 운전자 권익을 보호하기 위해 사용됩니다.'
        ]
      },
      {
        title: '취소 수수료를 지불해야 하는 경우',
        content: [
          '지정된 시간을 초과하여 주문을 취소하고 운전자에게 빈주행 비용이 발생한 경우, 보상으로 취소 수수료를 지불해야 합니다.',
          '구체적인 취소 수수료 기준은 공급업체 규칙에 따라 계산되며, 취소 시 시스템이 해당 수수료를 표시합니다.'
        ]
      },
      {
        title: '취소 수수료를 지불할 필요가 없는 경우',
        content: [
          '지정된 시간 내에 주문을 취소하는 경우 취소 수수료를 지불할 필요가 없습니다.',
          {
            title:
              '다음과 같은 이유로 주문을 취소하는 경우 취소 수수료가 면제될 수 있습니다:',
            content: [
              '운전자가 적극적으로 주문을 취소함',
              '운전자가 예정 시간에 승차 지점에 도착하지 않음',
              '운전자가 승객을 거부하거나 이유 없이 오지 않음',
              '운전자 이유로 주문이 정상적으로 진행될 수 없는 기타 상황'
            ]
          },
          '위의 상황으로 인해 취소 수수료가 발생한 경우, 고객 서비스에 연락하여 항의할 수 있으며, 플랫폼은 확인 후 취소 수수료 면제 처리를 진행합니다.'
        ]
      },
      {
        title: '분쟁 해결',
        content: [
          '취소 수수료에 이의가 있는 경우, 주문이 취소된 후 24시간 이내에 고객 서비스에 연락하여 항의할 수 있습니다.',
          '플랫폼은 주문 기록, 운전자 피드백 및 관련 증거를 바탕으로 확인하고, 확인 완료 후 최종 결정을 내립니다.'
        ]
      }
    ],
    bottomDesc:
      'GOx 일본 택시 플랫폼을 선택해 주셔서 감사합니다. 즐거운 여행 되세요!'
  },
  components: {
    confirm: {
      confirm: '확인',
      cancel: '취소'
    },
    map: {
      locationPermission: {
        harmony: '현재 위치를 가져올 수 없습니다. 「설정 > 개인정보 보호 및 보안 > 위치」에서 위치 서비스를 켜고 이 서비스의 위치 접근을 허용해 주세요.',
        wechat: '현재 위치를 가져올 수 없습니다. 기기의 「설정」에서 위치 서비스를 켜고 WeChat의 위치 접근을 허용해 주세요.',
        ios: '현재 위치를 가져올 수 없습니다. 「설정 > 개인정보 보호 및 보안 > 위치 서비스」에서 위치 서비스를 켜고 사용 중인 브라우저의 위치 접근을 허용해 주세요.',
        android: '현재 위치를 가져올 수 없습니다. 「설정 > 위치」에서 위치를 켜고 브라우저의 사이트 설정에서 이 사이트의 위치 접근을 허용해 주세요.',
        default: '현재 위치를 가져올 수 없습니다. 브라우저 설정에서 이 사이트의 위치 접근을 허용해 주세요.'
      },
      locationPermissionConfirm: '확인'
    },
    hotel: {
      back: '뒤로가기',
      multiLanguage: 'EN/中/日/한'
    }
  },
  common: {
    noData: '데이터가 없습니다',
    copyright: '© LINKTIVITY Inc. All Rights Reserved.'
  },
  errorCode: {
    [ErrorCode.Internal]: '시스템이 혼잡합니다. 잠시 후 다시 시도해 주세요',
    [ErrorCode.Unauthorized]: '세션이 만료되었습니다. 다시 로그인해 주세요',
    [ErrorCode.InvalidArgument]:
      '입력 정보가 올바르지 않습니다. 다시 시도해 주세요',
    [ErrorCode.PaymentFailed]: '결제에 실패했습니다. 다시 시도해 주세요',
    [ErrorCode.PendingPaymentExist]:
      '결제 대기 중인 주문이 있습니다. 먼저 해당 결제를 완료해 주세요',
    [ErrorCode.PaymentNotCompleted]:
      '결제가 완료되지 않았습니다. 결제를 계속 진행해 주세요',
    [ErrorCode.LoginFailed]: '로그인에 실패했습니다. 다시 시도해 주세요',
    [ErrorCode.RefundFailed]: '환불에 실패했습니다. 고객센터로 문의해 주세요',
    [ErrorCode.AccessTokenExpired]:
      '로그인 세션이 만료되었습니다. 다시 로그인해 주세요.',
    [ErrorCode.TaxiNotFound]:
      '사용 가능한 차량이 없습니다. 잠시 후 다시 시도해 주세요',
    [ErrorCode.InvalidLocation]: '잘못된 위치입니다. 다시 선택해 주세요',
    [ErrorCode.NotCancellable]: '현재 주문은 취소할 수 없습니다',
    [ErrorCode.DeadlineExceeded]:
      '시스템이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.',
    [ErrorCode.CouponNotFound]: '해당 쿠폰이 존재하지 않습니다.',
    [ErrorCode.CouponExpired]: '쿠폰이 만료되었습니다.',
    [ErrorCode.CouponAlreadyUsed]: '쿠폰이 이미 사용되었습니다.',
    [ErrorCode.CouponNotApplicable]: '사용할 수 없는 쿠폰입니다.',
    [ErrorCode.CouponAlreadyRedeemed]: '이미 이 유형의 쿠폰을 교환하셨습니다.',
    [ErrorCode.CouponOutOfAllotment]: '쿠폰이 모두 소진되었습니다.',
    [ErrorCode.CouponEventEnded]: '쿠폰 이벤트가 종료되었습니다.',
    [ErrorCode.CouponEventNotStarted]: '쿠폰 이벤트가 아직 시작되지 않았습니다.'
  },
  firebase: {
    'auth/wrong-password': '로그인 이름 또는 비밀번호가 잘못되었습니다.',
    'auth/user-not-found': '로그인 이름 또는 비밀번호가 잘못되었습니다.',
    'auth/email-already-in-use': '이메일 주소가 이미 사용 중입니다.',
    'auth/too-many-requests':
      '로그인 시도 횟수가 초과되었습니다. 잠시 후 다시 시도하거나 비밀번호를 재설정해 주세요.'
  }
};
